// Globaler 402-Handler: Wenn irgendein /api-Aufruf 402 (subscription_required)
// liefert, soll die App eine einheitliche, freundliche Meldung zeigen und auf die
// Paketauswahl leiten — statt einer rohen Fehlermeldung oder eines leeren Zustands.
//
// Der Query-Client lebt außerhalb des React-Routers und kann daher nicht selbst
// navigieren. Stattdessen meldet er den Sperr-Fall über dieses kleine Pub/Sub an
// eine im Router montierte Komponente (SubscriptionLockNotice), die Meldung +
// Navigation übernimmt.

export const SUBSCRIPTION_REQUIRED_MESSAGE = "Aktives Abo erforderlich";

// Bereiche, die ohne aktives Abo erreichbar bleiben — dort soll bei einer 402
// nicht umgeleitet werden (sonst käme der Nutzer nie zur Paketauswahl/Verwaltung).
export const NO_REDIRECT_PREFIXES = ["/pakete", "/abo", "/einstellungen"];

/** True, wenn der Pfad zu einem Bereich gehört, der ohne Abo erreichbar bleibt. */
export function isOnNoRedirectPage(pathname: string): boolean {
  return NO_REDIRECT_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(p + "/"),
  );
}

type Listener = () => void;

const listeners = new Set<Listener>();
let lastFired = 0;

/** Registriert einen Listener; gibt eine Cleanup-Funktion zurück. */
export function onSubscriptionRequired(fn: Listener): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

/**
 * Meldet, dass ein API-Aufruf wegen fehlendem Abo (402) blockiert wurde.
 * Entprellt, damit gleichzeitige Hintergrund-Queries nicht mehrfach feuern.
 */
export function notifySubscriptionRequired(): void {
  const now = Date.now();
  if (now - lastFired < 1500) return;
  lastFired = now;
  for (const fn of listeners) fn();
}
